// PURPOSE: Preview the exact plain-text weekly email. CONTRACT: spec 080 B2, 65ch reading width. DEPENDS: composer subject and signed body. CEILING: never renders HTML from records or sends mail.
export function WeeklyPreview({ subject, body }: { subject: string; body: string }) {
  return <section className="weekly-preview" aria-label="Email preview"><h3>{subject || 'No subject'}</h3><div>{body || 'No message yet.'}</div></section>;
}
